import { useEffect } from 'react';
import { telegramAuthCrypto } from 'src/config/api';
import { withAppContext } from 'src/store/initAppContext';


const TelegramAuthCallback = (props) => {
        const {
        app: { brandId }
    } = props;



  useEffect(() => {
    if (typeof window === 'undefined') return;

    const hash = window.location.hash;
    const _origin = window.location.origin;

    if (hash.startsWith('#tgAuthResult=')) {
      try {
        const encoded = hash.replace('#tgAuthResult=', '');
        const user = JSON.parse(atob(encoded));

        const params = {
          brand_id: brandId,
          first_name: user.first_name,
          last_name: user.last_name,
          username: user.username,
          hash: user.hash,
          id: user.id,
          auth_date: user.auth_date,
          domain: _origin,
        };

        telegramAuthCrypto(params)
          .then((response) => {
            const { response_url } = response?.data?.data;
            if (response_url) {
              window.location.href = response_url;
            } else {
              console.error('Login failed.');
            }
          })
          .catch((error) => {
            console.error('Telegram auth failed:', error);
          });

        // Optional: clear the hash from the URL
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      } catch (err) {
        console.error('Invalid Telegram user data:', err);
      }
    }
  }, []);

  return null; // or a spinner/loading state
};

export default withAppContext(TelegramAuthCallback);
